import { render, staticRenderFns } from "./Comunicazione.vue?vue&type=template&id=b2007ac0&scoped=true&"
import script from "./Comunicazione.vue?vue&type=script&lang=js&"
export * from "./Comunicazione.vue?vue&type=script&lang=js&"
import style0 from "./Comunicazione.vue?vue&type=style&index=0&id=b2007ac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2007ac0",
  null
  
)

export default component.exports